import { Box, useMediaQuery, useTheme } from "@mui/material";
import SalesReportDataProvider from "./SalesReportDataProvider";
import SalesReportHeader from "./SalesReportHeader";
import SalesReportProvider from "./SalesReportProvider";
import SalesReportChart from "./components/SalesReportChart";
import SalesReportFilter from "./components/SalesReportFilter";
import SalesReportPivotTable from "./components/SalesReportPivotTable";
import SalesReportToolbar from "./components/SalesReportToolbar";

export interface SalesReportProps {}

const SalesReport: React.FC<SalesReportProps> = ({}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <SalesReportDataProvider>
      <SalesReportHeader />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          ml: isMobile ? -3 : 0,
          mr: isMobile ? -3 : 0,
          "& .MuiPaper-root": {
            borderRadius: isMobile ? 0 : undefined,
          },
        }}
      >
        <SalesReportProvider>
          <SalesReportFilter />
          <SalesReportToolbar />
          <SalesReportChart />
          <SalesReportPivotTable />
        </SalesReportProvider>
      </Box>
    </SalesReportDataProvider>
  );
};
export default SalesReport;
